import React, {useState} from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper component that adds long pressed effect functionality
 *
 * https://stackoverflow.com/questions/48048957/react-long-press-event
 * @param props
 * @returns {*}
 * @constructor
 */
function LongPressListener(props) {
    const {onLongPressed, listenerTimeout} = props;

    const [longPressTimer, setLongPressTimer] = useState(0);

    const handleButtonPress = () => {
        setLongPressTimer(setTimeout( onLongPressed, listenerTimeout));
    };

    const handleButtonRelease = () =>  {
        clearTimeout(longPressTimer);
    };

    return (
        <div
            onTouchStart={handleButtonPress}
            onTouchEnd={handleButtonRelease}
            onMouseDown={handleButtonPress}
            onMouseUp={handleButtonRelease}
            onMouseLeave={handleButtonRelease}>
            {props.children}
        </div>
    );
}

LongPressListener.propTypes = {
    onLongPressed: PropTypes.func.isRequired,
    listenerTimeout: PropTypes.number
};
LongPressListener.defaultProps = {
    listenerTimeout: 700
};

export default LongPressListener;
